import _defineProperty from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import y, { useEffect as ie } from "react";
import { MaxResolution as be, MinResolution as xe, RenditionOrder as Te } from "@mux/playback-core";
import { MediaError as he } from "@mux/mux-player";

var p = {
  className: "class",
  classname: "class",
  htmlFor: "for",
  crossOrigin: "crossorigin",
  viewBox: "viewBox",
  playsInline: "playsinline",
  autoPlay: "autoplay",
  playbackRate: "playbackrate"
},
    _ = function _(e) {
  return e == null;
},
    q = function q(e, n) {
  return _(n) ? !1 : e in n;
},
    J = function J(e) {
  return e.replace(/[A-Z]/g, function (n) {
    return "-".concat(n.toLowerCase());
  });
},
    Y = function Y(e, n) {
  if (!(typeof n == "boolean" && !n)) {
    if (q(e, p)) return p[e];
    if (typeof n != null) return /[A-Z]/.test(e) ? J(e) : e;
  }
};

var $ = function $(e, n) {
  return typeof e == "boolean" ? "" : e;
},
    c = function c() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.entries(e).reduce(function (n, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        t = _ref2[0],
        o = _ref2[1];

    var a = Y(t, o);
    if (!a) return n;
    var i = $(o, t);
    return n[a] = i, n;
  }, {});
};

import { useRef as se } from "react";
import { useEffect as Q, useRef as X } from "react";

var m = function m() {
  for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
    e[_key] = arguments[_key];
  }

  var n = X(null);
  return Q(function () {
    e.forEach(function (t) {
      !t || (typeof t == "function" ? t(n.current) : t.current = n.current);
    });
  }, [e]), n;
};

import { useEffect as B } from "react";

var ee = Object.prototype.hasOwnProperty,
    ne = function ne(e, n) {
  if (Object.is(e, n)) return !0;
  if (typeof e != "object" || e === null || typeof n != "object" || n === null) return !1;
  if (Array.isArray(e)) return !Array.isArray(n) || e.length !== n.length ? !1 : e.some(function (a, i) {
    return n[i] === a;
  });
  var t = Object.keys(e),
      o = Object.keys(n);
  if (t.length !== o.length) return !1;

  for (var a = 0; a < t.length; a++) {
    if (!ee.call(n, t[a]) || !Object.is(e[t[a]], n[t[a]])) return !1;
  }

  return !0;
},
    d = function d(e, n, t) {
  return !ne(n, e[t]);
},
    te = function te(e, n, t) {
  e[t] = n;
},
    re = function re(e, n, t) {
  var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : te;
  var a = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : d;
  return B(function () {
    var i = t == null ? void 0 : t.current;
    !i || !a(i, n, e) || o(i, n, e);
  }, [t == null ? void 0 : t.current, n]);
},
    l = re;

var ae = function ae() {
  try {
    return "2.2.0";
  } catch (_unused) {}

  return "UNKNOWN";
},
    oe = ae(),
    E = function E() {
  return oe;
};

var le = y.forwardRef(function (_ref3, t) {
  var e = _ref3.children,
      n = _objectWithoutProperties(_ref3, ["children"]);

  return y.createElement("mux-player", c(_objectSpread(_objectSpread({}, n), {}, {
    ref: t
  })), e);
}),
    r = function r(e, n, t) {
  return ie(function () {
    var o = n == null ? void 0 : n.current;
    if (!(!o || !t)) return o.addEventListener(e, t), function () {
      o.removeEventListener(e, t);
    };
  }, [n == null ? void 0 : n.current, t]);
},
    ue = function ue(e, n) {
  var t = n.onAbort,
      o = n.onCanPlay,
      a = n.onCanPlayThrough,
      i = n.onEmptied,
      g = n.onLoadStart,
      M = n.onLoadedData,
      f = n.onLoadedMetadata,
      P = n.onProgress,
      v = n.onDurationChange,
      b = n.onVolumeChange,
      x = n.onRateChange,
      T = n.onResize,
      R = n.onWaiting,
      h = n.onPlay,
      k = n.onPlaying,
      C = n.onTimeUpdate,
      L = n.onPause,
      O = n.onSeeking,
      S = n.onSeeked,
      G = n.onStalled,
      w = n.onSuspend,
      V = n.onEnded,
      A = n.onError,
      N = n.onCuePointChange,
      I = n.onCuePointsChange,
      K = n.metadata,
      D = n.tokens,
      U = n.paused,
      H = n.playbackId,
      j = n.playbackRates,
      z = n.currentTime,
      F = n.themeProps,
      W = _objectWithoutProperties(n, ["onAbort", "onCanPlay", "onCanPlayThrough", "onEmptied", "onLoadStart", "onLoadedData", "onLoadedMetadata", "onProgress", "onDurationChange", "onVolumeChange", "onRateChange", "onResize", "onWaiting", "onPlay", "onPlaying", "onTimeUpdate", "onPause", "onSeeking", "onSeeked", "onStalled", "onSuspend", "onEnded", "onError", "onCuePointChange", "onCuePointsChange", "metadata", "tokens", "paused", "playbackId", "playbackRates", "currentTime", "themeProps"]);

  return l("playbackRates", j, e), l("metadata", K, e), l("themeProps", F, e), l("tokens", D, e), l("playbackId", H, e), l("paused", U, e, function (s, u) {
    u != null && (u ? s.pause() : s.play());
  }, function (s, u, Z) {
    return s.hasAttribute("autoplay") && !s.hasPlayed ? !1 : d(s, u, Z);
  }), l("currentTime", z, e, function (s, u) {
    u != null && (s.currentTime = u);
  }), r("abort", e, t), r("canplay", e, o), r("canplaythrough", e, a), r("emptied", e, i), r("loadstart", e, g), r("loadeddata", e, M), r("loadedmetadata", e, f), r("progress", e, P), r("durationchange", e, v), r("volumechange", e, b), r("ratechange", e, x), r("resize", e, T), r("waiting", e, R), r("play", e, h), r("playing", e, k), r("timeupdate", e, C), r("pause", e, L), r("seeking", e, O), r("seeked", e, S), r("stalled", e, G), r("suspend", e, w), r("ended", e, V), r("error", e, A), r("cuepointchange", e, N), r("cuepointschange", e, I), [W];
},
    ye = E(),
    de = "mux-player-react",
    pe = y.forwardRef(function (e, n) {
  var t = se(null),
      o = m(t, n),
      _ue = ue(t, e),
      _ue2 = _slicedToArray(_ue, 1),
      a = _ue2[0];

  return y.createElement(le, _objectSpread({
    ref: o,
    playerSoftwareName: de,
    playerSoftwareVersion: ye
  }, a));
}),
    Ge = pe;

export { be as MaxResolution, he as MediaError, xe as MinResolution, Te as RenditionOrder, Ge as default };